export const analyticsFr = {
  bookingAnalytics: {
    navigation: {
      analytics: 'Analytiques',
    },
    title: 'Analytiques de Réservation',
    description: 'Suivez les performances de votre studio et le comportement des réservations',
    banner: 'Les analyses sont suivies depuis la page de réservation publique. La collecte de données commence lorsque les utilisateurs visitent votre page studio.',

    tabs: {
      overview: 'Aperçu',
      funnel: 'Entonnoir de Réservation',
      performance: 'Performance',
      behavior: 'Comportement Utilisateur',
    },

    overview: {
      total_views: 'Vues Totales',
      booking_starts: 'Débuts de Réservation',
      completions: 'Complétions',
      conversion_rate: 'Taux de Conversion',
      all_time: 'Depuis toujours',
      users_who_started: 'Utilisateurs ayant commencé une réservation',
      successful_bookings: 'Réservations réussies',
      view_to_booking: 'Vue à réservation',
    },

    funnel: {
      title: 'Analyse de l\'Entonnoir de Réservation',
      description: 'Suivez la progression des utilisateurs dans le processus de réservation',
      studio_views: 'Vues de la Page Studio',
      booking_starts: 'Réservation Commencée',
      room_selections: 'Salle Sélectionnée',
      date_selections: 'Date/Heure Sélectionnée',
      completions: 'Réservation Complétée',
    },

    performance: {
      coming_soon: 'Métriques de performance détaillées bientôt disponibles. Suivez les salles populaires, les créneaux horaires et les modèles de réservation.',
    },

    behavior: {
      coming_soon: 'Analyse du comportement utilisateur bientôt disponible. Comprenez l\'utilisation des appareils, les modèles d\'engagement et les interactions utilisateur.',
    },

    coming_soon: {
      title: 'Analyses Détaillées Bientôt Disponibles',
      description: 'Nous collectons actuellement les données analytiques de votre page de réservation. Une fois que suffisamment de données sont collectées, vous verrez des graphiques détaillés, des graphes et des insights sur les performances de votre studio, les heures de réservation populaires, les préférences de salles et les métriques de conversion.',
    },

    sharing: {
      title: 'Analyses de Partage',
      description: 'Suivez comment votre studio est partagé et mesurez le succès des références',
      no_data: 'Pas encore de données de partage. Partagez votre studio pour commencer le suivi !',

      overview: {
        total_shares: 'Partages Totaux',
        total_clicks: 'Clics sur les Liens',
        total_bookings: 'Réservations depuis les Partages',
        total_revenue: 'Revenus depuis les Partages',
        conversion_rate: 'Taux de Conversion des Partages',
        click_to_view: 'Taux Clic vers Vue',
        view_to_booking: 'Taux Vue vers Réservation',
      },

      funnel: {
        title: 'Entonnoir de Conversion des Partages',
        description: 'Suivez comment les liens partagés se convertissent en réservations',
        clicks: 'Clics sur les Liens',
        views: 'Vues du Studio',
        booking_starts: 'Réservation Commencée',
        completions: 'Réservations Complétées',
      },

      methods: {
        title: 'Performance des Méthodes de Partage',
        description: 'Voyez quelles plateformes génèrent le plus de réservations',
      },

      leaderboard: {
        title: 'Meilleurs Partageurs',
        description: 'Utilisateurs ayant généré le plus de revenus par le partage',
        rank: 'Rang',
        name: 'Nom',
        shares: 'Partages',
        bookings: 'Réservations',
        revenue: 'Revenus',
        rewards: 'Récompenses',
      },
    },
  },
};
